export const PROFILE_TYPE_ORGANIZATION = 'organization';
export const PROFILE_TYPE_COMPANY = 'company';
